import './RoundedXButton.scss';

function RoundedXButton({ ...props }) {
  return <button {...props} className="RoundedXButton" type="button" />;
}

export default RoundedXButton;
